document.addEventListener('DOMContentLoaded', () => {
  const swiperEl = document.querySelector('swiper-container');
  const swiperParams = {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    autoHeight: true,
    calculateHeight: false,
    navigation: {
      nextEl: '.slider-button-next',
      prevEl: '.slider-button-prev',
    },
    breakpoints: {
      1500: {
        spaceBetween: 35,
        slidesPerView: 4.5,
      },
      1200: {
        spaceBetween: 28,
        slidesPerView: 3.5,
      },
      990: {
        spaceBetween: 24,
        slidesPerView: 2.5,
      },
      750: {
        spaceBetween: 24,
        slidesPerView: 1.8,
      },
      550: {
        spaceBetween: 24,
        slidesPerView: 1.5,
      },
      430: {
        spaceBetween: 20,
        slidesPerView: 1.2,
      },
      380: {
        spaceBetween: 16,
        slidesPerView: 1.2,
      },
      360: {
        spaceBetween: 16,
        slidesPerView: 1.1,
      },
    },
  };

  // now we need to assign all parameters to Swiper element
  Object.assign(swiperEl, swiperParams);

  // and now initialize it
  swiperEl.initialize();
});
